import {Brick, Predicate, Query, registerBrick} from 'olympe';
import PurchaseRequestDM from '../../models/cloudobjects/PurchaseRequestDM';

/**
 * This brick parse and process a given EPR ID, and determine the corresponding tag based on the query results.
 * If no matching tag is found, it sets an empty tag and logs the absence of an EPR ID match.
 */
export default class EPRIDToTag extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} ePRID
     * @param {function()} forwardEvent
     * @param {function(string)} setTag
     */
    update($, [ePRID], [forwardEvent, setTag]) {
        const EPRid = ePRID.startsWith('EPR-') ? ePRID.substring(4) : ePRID;

        Query
            .instancesOf(PurchaseRequestDM)
            .filter(Predicate.equals(PurchaseRequestDM.epridProp, EPRid.toString()))
            .execute()
            .then((queryResult) => {
                const pr = queryResult.getFirst();
                if (pr) {
                    setTag(pr.getTag());
                } else {
                    console.log(`There is no PR with this EPR id : EPR-(${EPRid}).`);
                    setTag('');
                }
                forwardEvent();
            });
    }
}

registerBrick('01852edf6728ef56598c', EPRIDToTag);
